import { Component, HostListener, Injector, OnInit } from '@angular/core';
import { BaseView } from 'src/app/submodules/angular-ui-common/base-view';
import { SecurityDataService } from 'src/app/submodules/angular-common/security-data.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-cookie-policy',
  templateUrl: './cookie-policy.component.html',
  styleUrls: ['./cookie-policy.component.scss']
})
export class CookiePolicyComponent extends BaseView {

  constructor(
    protected _injector: Injector
   ) { 
    super(_injector);
  }

  @HostListener('document:click', ['$event'])
  private onClick(event) {
    if(event.target.className.split(' ').includes('goToInformativaGdpr'))  
      this.goToInformativaGdpr()
    else if(event.target.className.split(' ').includes('goToPywik'))  
      this.goToPywik()
    else if(event.target.className.split(' ').includes('revokeCookiePolicyConsent'))  
      this.revokeCookiePolicyConsent()
  }

  async goToInformativaGdpr(){
    window.open('https://www.lavoro.gov.it/Documents/informativa_GDPR.pdf', "_blank");
  }

  async goToPywik(){
    window.open('https://matomo.org/privacy-policy/', "_blank");
  }

  revokeCookiePolicyConsent(){
    this._injector.get(SecurityDataService).revokeCookiePolicyConsent();
    this._injector.get(Router).navigate(['/home']);
  }

}
